import { defineNuxtMiddleware } from '@nuxtjs/composition-api'
import { keyOfAuthToken } from '~/composables/useAuth'

export default defineNuxtMiddleware(({ app, redirect, route }) => {
  const token = app.$storage.getCookie(keyOfAuthToken)
  const routeName = route?.name?.split('___')[0]

  if (!token) {
    redirect(
      app.localePath({
        name: 'login',
        query: {
          redirect: JSON.stringify({
            name: routeName,
            query: route.query,
            params: route.params,
          }),
        },
      })
    )
  }
})
